import React from "react"

import { Link, withRouter } from "react-router-dom";
import moment from "moment";

import BaseTable from "./BaseTable"
import ViewCell from "./cells/ViewCell"
import EarningsDetail from "../modals/EarningsDetail"

class EarningsTable extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      live: props.live,
      showDetailModal: false,
      selectedReferrerId: null
    }

    this.table = React.createRef()
  }

  _getColumns(){
    return [
      {
        Header: 'Referrer Name',
        id: 'referrer_name',
        accessor: 'referrer_name'
      },
      {
        Header: 'Email',
        id: 'referrer_email',
        accessor: 'referrer_email'
      },
      {
        Header: 'Active Pro Users',
        id: 'commissions_count',
        accessor: 'commissions_count'
      },
      {
        Header: 'Monthly Earnings',
        id: 'monthly_earnings',
        accessor: commission => `€${commission.monthly_earnings.toFixed(2)}`
      },
      {
        Header: 'First Earning Date',
        id: 'first_commission_date',
        accessor: commission => moment(commission.first_commission_date).format('DD MMM YYYY') || '-'
      },
      {
        Header: 'Actions',
        sortable: false,
        exportable: false,
        headerClassName: 'text-end',
        Cell: rowInfo => {
          let commission = rowInfo.original
          return (
            <div className="text-end">
              <ViewCell
                onViewClicked={() => this.setState({showDetailModal: true, selectedReferrerId: commission.referrer_id})}
              />
            </div>
          )
        }
      }
    ]
  }

  render() {
    let {
      showDetailModal,
      selectedReferrerId
    } = this.state

    const columns = this._getColumns()

    return (
      <>
        <BaseTable
          ref={this.table}
          endpoint={`${window.Api.ReferralCommission}`}
          noDataMessage={"No users with active earnings found"}
          title={this.props.title}
          subtitle={this.props.subtitle}
          columns={columns}
          defaultSorted={[
            {
              id: "monthly_earnings",
              desc: true
            }
          ]}
          showPaginationBottom={!this.props.latestResults}
          showFilter={this.props.showFilter}
          searchPlaceholder="Search by name or email..."
        />
        {
          showDetailModal &&
          <EarningsDetail
            show={showDetailModal}
            referrerId={selectedReferrerId}
            onHide={() => this.setState({showDetailModal: false, selectedReferrerId: null})}
          />
        }
      </>
    )

  }

}

EarningsTable.defaultProps = {
  showFilter: true,
  latestResults: false
}

export default withRouter(EarningsTable);
